import Cron from "croner";
import { useCallback, useEffect, useRef, useState } from "react";
import _ from 'lodash'
import moment from 'moment'

function getCronString(type:number){
    switch(type){
        case 1:
            return '*'
        case 2:
            const cron3Minute:number[] = []
            _.times(20,n=>{
              cron3Minute.push(n*3)
            })
            return cron3Minute.join(',')
        case 3:
            const cron5Minute:number[] = []
            _.times(12,n=>{
                cron5Minute.push(n*5)
            })
            return cron5Minute.join(',')
        case 0:
            const cron10Minute:number[] = []
            _.times(6,n=>{
              cron10Minute.push(n*10)
            })
            return cron10Minute.join(',')
    }
}

export function useCountdown(type:number,issueNumber:number,countdownCallback?:()=>void) {
    const [countDown,setCountdown] = useState<number>()
    const currentCron = useRef<Cron>()
    const currentInterval = useRef<NodeJS.Timeout>()
    const initCountDownCallback = useCallback(()=>{
        if(!type){
            return
        }
        if(currentCron.current){
            currentCron.current.stop()
        }
        if(currentInterval.current){
            clearInterval(currentInterval.current)
        }
        const cronString = type==30? `0,30 * * * * *` : `0 ${getCronString(type%4)} * * * *`
        currentCron.current = Cron(cronString, {}, (context:any) => {
            // nextRuntime = cron.nextRun()
             countdownCallback && countdownCallback()
          }); 
        console.log('cron initialized')
        const nextRuntime = currentCron.current.nextRun()
        currentInterval.current = setInterval(()=>{
            // 进入
            const diff = -moment().diff(moment(nextRuntime),'seconds')
            if(diff<0){
                initCountDownCallback()
                // countdownCallback && countdownCallback()
            }
            if(diff>=0){
                setCountdown(diff)
            }
        },1000)
    },[type,countdownCallback]) 
    useEffect(()=>{
        initCountDownCallback()

        // 解构函数
        return ()=>{
            console.log('useCountdown released',currentInterval.current,type,issueNumber)
            if(currentCron.current){
                currentCron.current.stop()
            }
            if(currentInterval.current){
                clearInterval(currentInterval.current)
            }
        }
    },[type,issueNumber,countdownCallback])
    
    return [countDown]
    
    // next10Runtime = cron10.nextRun()

    // countdownInterval.current = setInterval(()=>{ 
    //   const _countdownData:{[key:string]:[value:number]} = {}
    //   paths.forEach(path=>{
    //     const [lottery,type] = path.split('_')
    //     switch(parseInt(type)%4){
    //       case 1:
    //         // @ts-ignore
    //         _countdownData[path] = -moment().diff(moment(next1Runtime),'seconds')
    //         break;
    //       case 2:
    //         // @ts-ignore
    //         _countdownData[path] = -moment().diff(moment(next3Runtime),'seconds')
    //         break;
    //       case 3:
    //         // @ts-ignore
    //         _countdownData[path] = -moment().diff(moment(next5Runtime),'seconds')
    //         break;
    //       case 0:
    //         // @ts-ignore
    //         _countdownData[path] = -moment().diff(moment(next10Runtime),'seconds')
    //         break;
    //     }
    //   })
    //   setCountDownData(_countdownData) 
    // },1000)
}